import { render, staticRenderFns } from "./InstituteGroupSubGroupEnrollment.vue?vue&type=template&id=33184323"
import script from "./InstituteGroupSubGroupEnrollment.vue?vue&type=script&lang=js"
export * from "./InstituteGroupSubGroupEnrollment.vue?vue&type=script&lang=js"
import style0 from "./InstituteGroupSubGroupEnrollment.vue?vue&type=style&index=0&id=33184323&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports